module.exports = __webpack_public_path__ + "static/assets/9e153bba4349d6cf9320e0cde0d2e147.svg";